export const BackButton = ({ onClick, text = "Back" }: { onClick: () => void, text?: string }) => {
  return (
    <button onClick={onClick} className={"text-action text-lg font-sans-bold relative top-[-30px] md:top-[-45px]"}>
      {text}
    </button>
  );
};